import axios from 'axios';

const supportApi = {
    async newChat({ name, locale }) {
        const response = await axios.post('/api/v2/support/chat', { name, locale });
        return response.data;
    },
    async getChatMessages(chatId) {
        const response = await axios.get(`/api/v2/support/chat/${chatId}/messages`);
        return response.data.response || [];
    },
    async rating(message, rating) {
        const url = `/api/v2/support/chat/${message.chatId}/message/${message.originalId}/rating/${rating}`;
        const response = await axios.post(url);
        return response.data;
    },
    async postSupportTicket(message, supportTicketRequest) {
        const url = `/api/v2/support/chat/${message.chatId}/message/${message.originalId}/support_request`;
        const response = await axios.post(url, supportTicketRequest);
        return response.data.response;
    },
};

export default supportApi;
